class CookiesBar {
  lsKey = 'sbCookiesBarAccepted';

  constructor() {
    this.init();
  } 

  init() {
    this.cacheDom();
    this.events();
  }

  cacheDom() {
    this.cookiesBar = document.querySelector('#sb-cookies-bar');
    this.acceptButton = document.querySelector('#sb-cookies-bar-btn');
  }

  events() {
    if (!this.cookiesBar || !this.acceptButton) {
      return; 
    }

    this.openBar();

    this.cookiesBar.addEventListener('click', () => this.closeBar(), { passive: true });
  }

  openBar() {
    if (!localStorage || /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent)) {
      return; 
    }

    const isAccepted = localStorage.getItem(this.lsKey);

    if (isAccepted === 'true') {
      return; 
    }

    setTimeout(() => {
      this.cookiesBar.style.display = 'block';
    }, 0);
  }

  closeBar() {
    this.cookiesBar.style.display = 'none';

    if (!localStorage) {
      return; 
    }

    localStorage.setItem(this.lsKey, 'true');
  }
}

var sbCookiesBar = new CookiesBar();